export const isDebug: boolean = (import.meta.env.VITE_DEBUG_MODE === 'true');

if (typeof window !== 'undefined' && isDebug) {
  (window as any).__DEBUG__ = true;
}
